import React from 'react';

export default function LoadingMessage() {
  return (
    <div className="splash-screen">
      <div className="loading-dot">.</div>
    </div>
  );
}